/// <reference path="Assistant.ts" />

namespace TerminalApp {
    export class QuickAuditAssistant extends Assistant {
        qa_menu = document.createElement("div");
        additional_container: HTMLElement;
        placement_quantity_input: HTMLInputElement;
        submit_button: HTMLElement;
        max_qty: HTMLElement;
        product_image: HTMLImageElement;
        product_info: HTMLElement;
        minus_btn: HTMLElement;
        plus_btn: HTMLElement;
        placement_info_box: HTMLElement;

        constructor() {
            super();
            this.qa_menu.innerHTML = `
            <div class="setting_group setting_group-custom">
                <h1 class="terminal-modal-h1">${SP.Localize("sentance_stock_audit")}</h1>
                <center>
                <div class='product_info'></div>
                <img class='product_image' src="" style="max-height: 300px; max-width: 90%;"></center>
                <div class="placement_info_box"></div>

                <div class="pick_status_box_big noselect">
                    <div class="button minus grad-gray"><i class="fas fa-minus" aria-hidden="true"></i></div>
                    <div class="input_box"><input class="placement_quantity" type="number"> / <span class="max_qty">2</span></div>
                    <div class="button plus grad-gray"><i class="fas fa-plus" aria-hidden="true"></i></div>
                </div>

                <div class="btn noselect grad-green"><span class="action">${SP.Localize("word_confirm")}</span></div>
            </div>`; 

            this.product_image = this.qa_menu.querySelector(".product_image");
            this.max_qty = this.qa_menu.querySelector(".max_qty");
            this.product_info = this.qa_menu.querySelector(".product_info");
            this.placement_quantity_input = this.qa_menu.querySelector(".placement_quantity");
            this.minus_btn = this.qa_menu.querySelector(".minus");
            this.plus_btn = this.qa_menu.querySelector(".plus");
            this.placement_info_box = this.qa_menu.querySelector(".placement_info_box");

            this.submit_button = this.qa_menu.querySelector(".btn");
            this.submit_button.addEventListener("click", async () => {
                var counted_qty = parseFloat(this.placement_quantity_input.value);
                var regulation = counted_qty - this.placementQuantity;

                var regulations = {} as any;
                regulations[this.item.id] = regulation;

                var data = {
                    itemRegulations: regulations,
                    placementId: this.placementId,
                    note: "",
                    reason: SP.AuditReason.StockAudit
                };

                var result = await SP.post<any>("/api/v1/audit/commit/", data);
                SP.Sounds.Success.play();
                this.close();
            });

            this.placement_quantity_input.addEventListener("keydown", (e) => {

                if (e.which == 13) this.submit_button.click();
            });

            this.plus_btn.addEventListener("click", () => {
      
            });

            SP.bindClickHold(this.plus_btn, 500, () => {
                var n = parseFloat(this.placement_quantity_input.value);
                this.placement_quantity_input.value = (n + 1).toString();
            }, () => {
                this.placement_quantity_input.value = this.max_qty.innerText;
            })

            SP.bindClickHold(this.minus_btn, 500, () => {
                var n = parseFloat(this.placement_quantity_input.value);
                this.placement_quantity_input.value = Math.max(0, n - 1).toString();
            }, () => {
                this.placement_quantity_input.value = "0";
            })

            this.container.appendChild(this.qa_menu);
        }

        hide() {
            this.qa_menu.style.display = "none";
        }

        open_qa() {
            this.hide();
            this.container.style.display = "block";
            this.qa_menu.style.display = "block";
        }

        clear() {
            //clear home buttons
            this.container.style.display = "none";
        }

        item: SP.ItemInfo;
        placementId: number;
        placementQuantity: number;

        // Define a new class property for storing the Promise resolve function.
        resolveOnClose: () => void;

        async open(slInfo: SP.StockingLotInfo) {
            SP.Sounds.Notification.play();
            this.placementQuantity = 0;
            this.placementId = slInfo.stockPlacementId;
            this.item = slInfo.item;

            

            this.product_info.innerHTML = `<b>${this.item.description}</b><br />${this.item.sku} <br /><small>${Object.keys(this.item.allBarcodes).join(", ")}</small> `
            this.product_image.src = this.item.imageUrl;

            //show placement
            var piBox = new PlacementInfoBox(slInfo.stockPlacementData, true, this.item);
            piBox.container.style.margin = "auto";
            this.placement_info_box.innerHTML = "";
            this.placement_info_box.append(piBox.container);

            //getTotalPlacemnetQty
            var placementLots = await SP.Data.StockingLot.getPlacementStockingLotInfos(this.placementId);
            placementLots.forEach(l => {
                if (l.item.id == this.item.id) {
                    this.placementQuantity += l.placementQuantity;
                }
            });

            this.max_qty.innerHTML = this.placementQuantity.toString();
            this.placement_quantity_input.value = this.placementQuantity.toString();

            // Promise is created only for the close operation.
            return new Promise<void>((resolve, reject) => {
                this.resolveOnClose = resolve; // This line has no TypeScript errors now
                this.open_qa();
            });
        }


        close() {
            // When close is called, resolve the Promise.
            if (this.resolveOnClose) {
                this.resolveOnClose();
            }
            super.close();
        }

    }


}